import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { AuthorizationRequestConfigurationService } from '../../configuration/auth/authorization-request-configuration/authorization-request-configuration.service';
import { ClientConfigurationService } from '../../configuration/auth/client/client-configuration.service';
import { AuthModule } from '../auth.module';
import { PKCEConfigurationService } from '../../configuration/auth/p-k-c-e/p-k-c-e-configuration.service';
import { AuthorityService } from '../authority/authority.service';


@Injectable({
  providedIn: AuthModule
})
export class PKCEAuthorizationRequestService {

  get clientConfiguration() {
    return this.clientConfigurationService.configuration;
  }

  get response_type() {
    return "code";
  }

  get redirect_uri() {
    return this.authorizationRequestConfiguration.redirect_uri;
  }

  get clientId() {
    return this.clientConfiguration.clientId;
  }

  get path() {
    return this.authorizationRequestConfiguration.path;
  }

  get scope() {
    return this.authorizationRequestConfiguration.scope;
  }

  get code_challenge_method() {
    return this.pkceConfiguration.code_challenge_method;
  }

  get pkceConfiguration() {
    return this.pkceConfigurationService.configuration;
  }

  get authorizationRequestConfiguration() {
    return this.authorizationRequestConfigurationService.configuration;
  }

  constructor(private authorizationRequestConfigurationService: AuthorizationRequestConfigurationService,
    private clientConfigurationService: ClientConfigurationService,
    private pkceConfigurationService: PKCEConfigurationService,
    private authorityService: AuthorityService) { }

  createHttpParamsOption(params) {
    return {
      fromObject: params
    };
  }

  createParams(code_challenge, prompt?) {
    const params: any =  {
      response_type: this.response_type,
      client_id: this.clientId,
      redirect_uri: this.redirect_uri,
    };
    if (this.scope) {
      params.scope = this.scope;
    }
    if (prompt) {
      params.prompt = prompt;
    }
    params.code_challenge_method = this.code_challenge_method;
    params.code_challenge = code_challenge;
    return new HttpParams(this.createHttpParamsOption(params));
  }

  createAuthorizationRequestUrl(code_challenge, prompt?) {
    return this.authorityService.createResourceUrlWithParams(this.path, this.createParams(code_challenge, prompt), true);
  }
}
